var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_243_9087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.40599 7.97027C8.01992 8.40943 7.54999 8.77058 7.02125 9.03108V10.5311C7.02125 10.6637 6.96858 10.7909 6.87481 10.8846C6.78104 10.9784 6.65386 11.0311 6.52125 11.0311H3.52125C3.38865 11.0311 3.26147 10.9784 3.1677 10.8846C3.07393 10.7909 3.02125 10.6637 3.02125 10.5311V9.03108C2.3017 8.67405 1.69083 8.13094 1.25205 7.45811C0.813277 6.78528 0.562593 6.00727 0.526028 5.20485C0.489463 4.40242 0.668348 3.60484 1.04411 2.89489C1.41988 2.18495 1.97882 1.58852 2.66292 1.16754C3.34702 0.746553 4.13134 0.516354 4.93445 0.50084C5.60446 0.487896 6.26717 0.62477 6.87481 0.899421",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02124 13.5H7.02124",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39479 3.93395C7.04386 3.8729 7.04386 3.36912 7.39479 3.30807C8.66614 3.08689 9.67733 2.11853 9.95328 0.857921L9.97444 0.761292C10.0503 0.414459 10.5442 0.4123 10.6231 0.758456L10.6488 0.871066C10.935 2.12572 11.9464 3.08591 13.2143 3.30647C13.567 3.36784 13.567 3.87418 13.2143 3.93554C11.9464 4.15611 10.935 5.1163 10.6488 6.37095L10.6231 6.48356C10.5442 6.82972 10.0503 6.82756 9.97444 6.48073L9.95328 6.3841C9.67733 5.1235 8.66614 4.15513 7.39479 3.93395Z",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_243_9087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordCheck);
export default __webpack_public_path__ + "static/media/Password-check.e497f5ac1d2f0a8ceec02d8a95ce47e4.svg";
export { ForwardRef as ReactComponent };